import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Sofa = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 25' {...rest}>
    {type === 'stroke' ? (
      <>
        <line
          x1='6.25'
          y1='18.243'
          x2='6.25'
          y2='19.743'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
        />
        <line
          x1='17.75'
          y1='18.243'
          x2='17.75'
          y2='19.743'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
        />
        <path
          d='M5 9.993v-2a3 3 0 0 1 3-3h8.5a2.5 2.5 0 0 1 2.5 2.5v2.5'
          stroke='currentColor'
          strokeWidth='1.5'
        />
        <path
          d='M20.5 17.493h-17a1 1 0 0 1-1-1v-5a2 2 0 0 1 4 0v1.5h11v-1.5a2 2 0 0 1 4 0v5a1 1 0 0 1-1 1'
          stroke='currentColor'
          strokeWidth='1.5'
        />
      </>
    ) : (
      <>
        <line
          x1='6.25'
          y1='18.25'
          x2='6.25'
          y2='19.75'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
        />
        <line
          x1='17.75'
          y1='18.25'
          x2='17.75'
          y2='19.75'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
        />
        <path
          d='M5 10V8a3 3 0 0 1 3-3h8.5A2.5 2.5 0 0 1 19 7.5V10'
          stroke='currentColor'
          strokeWidth='1.5'
        />
        <path
          d='M20.5 17.5h-17a1 1 0 0 1-1-1v-5a2 2 0 0 1 4 0V13h11v-1.5a2 2 0 0 1 4 0v5a1 1 0 0 1-1 1'
          fill='currentColor'
          stroke='currentColor'
          strokeWidth='1.5'
        />
      </>
    )}
  </IconBase>
);
